import { createElement } from "react";

/**
 * Same wording as MARKETING_HERO_TITLE in `@/constants/marketingHeroCopy`
 * with LinkedIn / Indeed styled like the landing hero (`.hero-highlight`).
 */
export function MarketingHeroHeadline({ as: Comp = "h1", className, ...rest }) {
  return createElement(
    Comp,
    { className, ...rest },
    <>
      The Jobs You Won&apos;t Find on{" "}
      <span className="hero-highlight">LinkedIn</span> or{" "}
      <span className="hero-highlight">Indeed</span>.
    </>
  );
}
